// import { forEach } from 'core-js/core/array';

const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchClass({ commit }, { eraporTemplateId, eraporIntegrationTemplateId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(
        `/api/erapor-integration/classroom?eraporTemplateId=${eraporTemplateId ? eraporTemplateId : ''}&eraporIntegrationTemplateId=${
          eraporIntegrationTemplateId ? eraporIntegrationTemplateId : ''
        }`
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListTemplate({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-template?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchCourseList({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-integration/course?classroomId=${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListGenerateErapor({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-generate?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async checkPublish({ commit }, { eraporIntegrationTemplateId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-generate/erapor-integration/${eraporIntegrationTemplateId}/published`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListStudent({ commit, rootGetters }, payload) {
    const currentRole = rootGetters['Auth/currentRole'];

    const { eraporIntegrationTemplateId, classroomId, search } = payload;

    let url;
    try {
      if (currentRole === 3) {
        const { studentId } = rootGetters['Auth/student'];
        url = `/api/erapor-generate-parent/student/${studentId}/classroom/${classroomId}`;

        const {
          data: { data }
        } = await window.axios.get(url);
        return data;
      } else if (currentRole == 5) {
        url = `/api/erapor-generate-student/classroom/${classroomId}`;
        const {
          data: { data }
        } = await window.axios.get(url);
        return data;
      } else if (currentRole == 4 && eraporIntegrationTemplateId) {
        url = `/api/erapor-generate/erapor-integration/${eraporIntegrationTemplateId}/student?search=${search ? search : ''}`;
        const {
          data: { data }
        } = await window.axios.get(url);
        return data;
      } else if (
        (currentRole == 4 && !eraporIntegrationTemplateId) ||
        (currentRole == 6 && !eraporIntegrationTemplateId) ||
        (currentRole == 2 && !eraporIntegrationTemplateId)
      ) {
        url = `/api/class/${classroomId}/erapor-students`;
        const {
          data: { data }
        } = await window.axios.get(url);
        return data;
      }
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListGroup({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-group`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListTemplateGroup({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-integration/erapor-template`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListIntegration({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-integration?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-template/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetailIntegartion({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-integration/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async viewDataTemplate({ commit }, { eraporIntegrationTemplateId, studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/erapor-generate/erapor-integration/${eraporIntegrationTemplateId}/student/${studentId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async viewDataClassErapor({ commit }, { classroomId, studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${classroomId}/student/${studentId}/erapor`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async exportDataTemplate({ commit }, { eraporIntegrationTemplateId, studentId, classroomId }) {
    try {
      if (eraporIntegrationTemplateId) {
        return await window.axios.get(`/api/erapor-generate/erapor-integration/${eraporIntegrationTemplateId}/student/${studentId}/export`, {
          responseType: 'arraybuffer'
        });
      } else {
        return await window.axios.get(`/api/class/${classroomId}/student/${studentId}/export`, {
          responseType: 'arraybuffer'
        });
      }
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  exportDataTemplateStudentParent({ commit, rootGetters }, { classroomId }) {
    const currentRole = rootGetters['Auth/currentRole'];
    try {
      if (currentRole == 5) {
        return window.axios.get(`/api/erapor-generate-student/classroom/${classroomId}/export`, {
          responseType: 'arraybuffer'
        });
      } else if (currentRole == 3) {
        const { studentId } = rootGetters['Auth/student'];
        return window.axios.get(`/api/erapor-generate-parent/student/${studentId}/classroom/${classroomId}/export`, {
          responseType: 'arraybuffer'
        });
      }
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  editErapor({ commit }, payload) {
    return window.axios.put(
      `/api/erapor-generate/erapor-integration/${payload.eraporIntegrationTemplateId}/student/${payload.studentId}`,
      payload.input
    );
  },
  // eslint-disable-next-line no-unused-vars
  generateTemplate({ commit }, id) {
    return window.axios.post(`/api/erapor-generate/erapor-integration/${id}`);
  },
  // eslint-disable-next-line no-unused-vars
  templatePublish({ commit }, payload) {
    return window.axios.put(`/api/erapor-generate/erapor-integration/${payload.eraporIntegrationTemplateId}/published`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  saveTemplate({ commit }, payload) {
    return window.axios.post(`/api/erapor-template`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateTemplate({ commit }, payload) {
    return window.axios.put(`/api/erapor-template/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  saveIntegration({ commit }, payload) {
    payload.attendances = payload.attendances.map(a => a.courseId);
    // payload.eraporGroupTemplates.forEach(data =>
    //   data.eraporTemplateCourses.forEach(datas => {
    //     let assignment = datas.assignments.map(aduh => aduh.assignmentId);
    //     datas.assignments = [];
    //     setTimeout(() => {
    //       datas.assignments = assignment;
    //     }, 400);
    //   })
    // );
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(window.axios.post('/api/erapor-integration', payload));
      }, 500);
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateIntegration({ commit }, payload) {
    payload.attendances = payload.attendances.map(a => a.courseId);
    // payload.eraporGroupTemplates.forEach(data =>
    //   data.eraporTemplateCourses.forEach(datas => {
    //     let assignment = datas.assignments.map(aduh => aduh.assignmentId);
    //     datas.assignments = [];
    //     setTimeout(() => {
    //       datas.assignments = assignment;
    //     }, 400);
    //   })
    // );
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(window.axios.put(`/api/erapor-integration/${payload.id}`, payload));
      }, 500);
    });
  },
  // eslint-disable-next-line no-unused-vars
  createGroup({ commit }, payload) {
    return window.axios.post(`/api/erapor-group`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateGroup({ commit }, payload) {
    return window.axios.put(`/api/erapor-group/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroyTemplate({ commit }, payload) {
    return window.axios.delete(`/api/erapor-template/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  destroyIntreg({ commit }, payload) {
    return window.axios.delete(`/api/erapor-integration/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  destroyGroup({ commit }, payload) {
    return window.axios.delete(`/api/erapor-group/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  checkPredicate({ commit }, { params, payloadRapor }) {
    console.log(params, payloadRapor);
    return window.axios.put(
      `/api/erapor-generate/erapor-integration/${params.eraporIntegrationTemplateId}/student/${params.studentId}/course-value`,
      payloadRapor
    );
  }
};

export default { namespaced, state, getters, mutations, actions };
